import { Button, ButtonType } from "@constellation-academy/epic-ui";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { useTranslation } from "@i18n/hooks";

import { type AddProductSelectionButtonProps } from "./add-product-selection-button.interface";
import { ProductSelectionForm } from "../../../../features/products/product-selection-form";

export const AddProductSelectionButton = ({ onSubmit }: AddProductSelectionButtonProps) => {
	const { t } = useTranslation("common");
	const [showDialog, setIsShowingDialog] = useState(false);

	const handleOnClick = () => {
		setIsShowingDialog(true);
	};
	const handleOnHide = () => {
		setIsShowingDialog(false);
	};
	const handleOnBack = () => {
		setIsShowingDialog(false);
	};

	return (
		<div>
			<div className="flex w-auto align-items-center">
				<Button
					label={t("generateCartLink.selectProduct")}
					type={ButtonType.Button}
					onClick={handleOnClick}
				/>
			</div>
			<Dialog
				header={<div>{t("generateCartLink.productCondition")}</div>}
				visible={showDialog}
				onHide={handleOnHide}
			>
				<ProductSelectionForm
					onBack={handleOnBack}
					onSubmit={onSubmit}
					initialValues={{
						product: {
							title: "",
							id: "",
						},
						amount: 0,
					}}
				/>
			</Dialog>
		</div>
	);
};
